import { useMediaQuery } from 'react-responsive';
import BackgroundAndHistory from "./images/images-home/BackgroundAndHistory";
import whiteMap from './images/images-home/transparentMapWhite.png';
import Footer from "./Footer";
import {motion} from 'framer-motion';
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { MainInfoWrapper } from "./MainInfoWrapper";
import MapSVG from './images/images-home/MapSVG';
import HomeAndTree from './images/images-home/HomeAndTree';



const InfoBoxes = ({isInIFrame}) => {

    const { allInfo } = useContext(MainInfoWrapper)

    const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1350px)'})
    
    const navigate = useNavigate()

    return (  
        <div>
            <motion.div id="mainInfoContainer"
                initial={{ opacity: 0  }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1, duration: 1.5 }}
                style={{
                    marginBottom: (isInIFrame && !isDesktopOrLaptop) ? '70px' : ''
                }}
            >

                {!isDesktopOrLaptop &&
                <div className="infoElement-doubleBox" 
                     onClick={() => navigate('./general-info')} 
                     style={{
                        cursor: isInIFrame ? 'pointer' : ''
                    }}
                >
                    <BackgroundAndHistory size={'55px'} marginRight={'20px'}/>
                    <h1 id="history">רקע כללי</h1>
                </div>
                }


                {isDesktopOrLaptop &&
                <div className="infoElement-doubleBox" onClick={() => navigate('./general-info')}>
                    <div className='iconAndTitle-centeringContainer'>
                        <div className="mainInfo-icon-doubleBox">
                            <HomeAndTree />
                        </div>
                        <div className="mainInfo-title mainInfo-title-white">
                            רקע כללי
                        </div>
                    </div>
                </div>
                }





            {allInfo.map(infoElement => (
                <div className='infoElement-box' 
                     key={infoElement.id} 
                     onClick={() => navigate(infoElement.path)} 
                     style={{
                         cursor: isInIFrame ? 'pointer' : '',
                         backgroundColor: (isInIFrame && !isDesktopOrLaptop) ? 'rgb(255, 255, 255, 0.95)' : ''
                     }}
                >
                    <div className='iconAndTitle-centeringContainer'>
                        <div className="mainInfo-icon">
                            {infoElement.icon}
                        </div>
                        <div className="mainInfo-title">
                            {infoElement.title}
                        </div>
                    </div>
                </div>
            ))
            }

                {(!isDesktopOrLaptop && !isInIFrame) && 
                <div className="infoElement-map" 
                     onClick={() => navigate('./map')}
                     style={{
                        cursor: isInIFrame ? 'pointer' : '',
                        width: isInIFrame ? '45%' : '60%',
                        margin: isInIFrame ? '40px auto 45px' : '50px auto 94px',
                        background: isInIFrame ? 'rgba(133, 186, 132, 0.95)' : 'rgba(133, 186, 132, 0.9)'
                     }}
                >
                    <img src={whiteMap} className='transparent-map' alt='מפת שדה נחמיה'/>
                    <p className='mainInfo-title-map'>מפת הקיבוץ</p>
                </div>
                }

                {(isDesktopOrLaptop && !isInIFrame) && 
                    <div className='infoElement-map' onClick={() => navigate('./map')} >
                        <div className='iconAndTitle-centeringContainer'>
                            <div className="mainInfo-icon">
                                <MapSVG size={'50px'} color={'#ffffff'} />
                            </div>
                            <div className="mainInfo-title mainInfo-title-white-map">
                                מפת הקיבוץ
                            </div>
                        </div>
                    </div>
                }
                

                {(!isDesktopOrLaptop && !isInIFrame) && 
                <Footer/>
                }
            
            </motion.div>
        </div>
    );
}
 
export default InfoBoxes;